// src/hooks/useConfig.js
import { useState, useEffect } from 'react';

/**
 * Custom hook to load and cache the application configuration from config.json.
 * This ensures the config is loaded only once during the app lifecycle.
 * 
 * @returns {Object} { config, loading, error }
 */
export function useConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    (async () => {
      try {
        setLoading(true);
        const res = await fetch('/config.json');
        if (!res.ok) {
          throw new Error(`Failed to load config.json: ${res.status} ${res.statusText}`);
        }
        const json = await res.json();
        if (mounted) setConfig(json);
      } catch (e) {
        if (mounted) setError(e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return { config, loading, error };
}